<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :items="staffs"
    v-bind="this.$attrs"
    :options.sync="tableOptions"
    loading-text="Đang Tải"
    :server-items-length="totalItems"
    :footer-props="footerTable"
    :loading="loading"
  >
    <template v-slot:[`item.name`]="{ item }">
      <router-link style="text-decoration: none" :to="'/staff/' + item.id">
        {{ item.name }}
      </router-link>
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyy }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
const originHeaders = [
  { text: 'Tên', value: 'name', align: 'left', sortable: false, show: true },
  { text: 'Tài khoản', value: 'code', align: 'left', sortable: false, show: true },
  { text: 'Vai trò', value: 'role.description', align: 'left', sortable: false, show: true },
  { text: 'Email', value: 'email', align: 'left', sortable: false, show: true },
  {
    text: 'Số Điện Thoại',
    value: 'phone',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Ngày tạo',
    value: 'createdAt',
    align: 'left',
    sortable: false,
    show: true
  }
]

export default {
  props: {
    role: String
  },
  data() {
    return {
      headers: originHeaders,
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false,
      tableOptions: {}
    }
  },
  created() {
    this.refresh()
  },
  computed: {
    ...mapState('staff', ['staffs', 'count', 'staff', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },

    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Nhân Viên'
      }
    }
  },
  methods: {
    ...mapActions('staff', ['searchStaffs', 'requestPageSettings']),
    async refresh(query) {
      await this.searchStaffs(query)
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
